import NavBar from "../pages/NavBar";
import Main from "../pages/Main";
import Solution from "../pages/Solution";
import Services from "../pages/Services";
import Contact from "../pages/Contact";
import Footer from "../pages/Footer";
import Team from "../pages/Team";
import Customers from "../pages/Customers";
const AuthLayout = () => {
  return <>
      <NavBar />

      <Main />

      <Services />

      <Solution />

      <Customers />
      
      <Team />

      <Contact />

      <Footer />
    </>;
};
export default AuthLayout;